import { FLOATING_BUTTON_ENTRY_POINTS } from "constants/index";
import gtagEventEmitter from "./gtagEventEmitter";
import getPageType from "@Utils/getPageType";

/**
 * Emits a Google Analytics event when AI chat is initiated
 * This is used whenever the Amber Copilot chatbot is opened
 */
const emitAiChatInitiatedEvent = (
  entry_point = FLOATING_BUTTON_ENTRY_POINTS.PAGE_BUTTON,
  experiment: "zoho_chatbot" | "zendesk_chatbot" = "zoho_chatbot",
) => {
  gtagEventEmitter({
    action: "ai_chat_initiated",
    category: "ai_chatbot",
    interaction_type: "click",
    page_type: getPageType(),
    feature: "ai_chatbot",
    experiment,
    entry_point,
  });
};

export default emitAiChatInitiatedEvent;
